@if (!loading) {
  <div
    class="scan-history"
    [class.scan-history--granted]="statusKind(latest) === 'granted'"
    [class.scan-history--denied]="statusKind(latest) === 'denied'"
    [class.scan-history--no-data]="statusKind(latest) === 'no-data'">
    <button
      type="button"
      class="scan-history__header"
      [class.scan-history__header--expandable]="expandable"
      [attr.aria-expanded]="expandable ? expanded : null"
      (click)="toggle()">

      <span class="scan-history__field">
        <span class="scan-history__label">{{ 'RELATIONS.TICKET-SCAN-HISTORY.LATEST-STATUS' | translate }}:</span>
        <span
          class="scan-history__value"
          [class.scan-history__status--granted]="statusKind(latest) === 'granted'"
          [class.scan-history__status--denied]="statusKind(latest) === 'denied'"
          [class.scan-history__status--no-data]="statusKind(latest) === 'no-data'">{{ statusKey(latest) | translate }}</span>
      </span>

      <span class="scan-history__field">
        <span class="scan-history__label">{{ 'RELATIONS.TICKET-SCAN-HISTORY.REASON' | translate }}</span>
        <span class="scan-history__value">{{ displayReason(latest?.Reason) | replaceOnEmpty }}</span>
      </span>

      <span class="scan-history__field">
        <span class="scan-history__label">{{ 'RELATIONS.TICKET-SCAN-HISTORY.SCANNED-AT' | translate }}</span>
        <span class="scan-history__value">{{ latest?.ScanTimeStamp | localDateTime | replaceOnEmpty }}</span>
      </span>

      <span class="scan-history__field">
        <span class="scan-history__label">{{ 'RELATIONS.TICKET-SCAN-HISTORY.ENTRANCE' | translate }}</span>
        <span class="scan-history__value">{{ latest?.Entrance | replaceOnEmpty }}</span>
      </span>

      <span class="scan-history__field">
        <span class="scan-history__label">{{ 'RELATIONS.TICKET-SCAN-HISTORY.BARCODE' | translate }}</span>
        <span class="scan-history__value scan-history__barcode">{{ latest?.Barcode | replaceOnEmpty }}</span>
      </span>

      @if (expandable) {
        <i class="fa-solid fa-chevron-down scan-history__chevron" [class.scan-history__chevron--open]="expanded" aria-hidden="true"></i>
      }
    </button>

    <div class="scan-history__body" [class.scan-history__body--open]="expanded">
      <div class="scan-history__body-inner">
        <div class="scan-history__scroll">
          <table class="table table-sm mb-0">
            <thead>
              <tr>
                <th>{{ 'RELATIONS.TICKET-SCAN-HISTORY.HEADER.STATUS' | translate }}</th>
                <th>{{ 'RELATIONS.TICKET-SCAN-HISTORY.HEADER.REASON' | translate }}</th>
                <th>{{ 'RELATIONS.TICKET-SCAN-HISTORY.HEADER.SCANNED-AT' | translate }}</th>
                <th>{{ 'RELATIONS.TICKET-SCAN-HISTORY.HEADER.ENTRANCE' | translate }}</th>
                <th>{{ 'RELATIONS.TICKET-SCAN-HISTORY.HEADER.BARCODE' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (scan of scans; track scan) {
                <tr>
                  <td
                    [class.scan-history__status--granted]="statusKind(scan) === 'granted'"
                    [class.scan-history__status--denied]="statusKind(scan) === 'denied'"
                    [class.scan-history__status--no-data]="statusKind(scan) === 'no-data'">{{ statusKey(scan) | translate }}</td>
                  <td>{{ displayReason(scan.Reason) | replaceOnEmpty }}</td>
                  <td>{{ scan.ScanTimeStamp | localDateTime | replaceOnEmpty }}</td>
                  <td>{{ scan.Entrance | replaceOnEmpty }}</td>
                  <td class="scan-history__barcode">{{ scan.Barcode | replaceOnEmpty }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
}
